import { render, staticRenderFns } from "./ProductInfoPriceTable.vue?vue&type=template&id=bdaab45a&scoped=true&"
import script from "./ProductInfoPriceTable.vue?vue&type=script&lang=js&"
export * from "./ProductInfoPriceTable.vue?vue&type=script&lang=js&"
import style0 from "./ProductInfoPriceTable.vue?vue&type=style&index=0&id=bdaab45a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdaab45a",
  null
  
)

export default component.exports